<template>
  <div class="end-page">
  	<template v-if="end">		
			<h2 class="title" v-html="end.title"></h2>
			<p class="end-page__score" v-if="getWin">{{ getMoney }} M€</p>
			
			<div class="end-page__characters">
				<img :src="end.character.img" :alt="end.character.name">
				<img :src="getPlayer.img" :alt="getPlayer.name">
			</div>

			<p class="end-page__text" v-html="end.text"></p>

			<div class="end-page__share">
				<div>				
					<p>Invitez vos amis à jouer</p>
					<socials :share="true"></socials>
				</div>
			</div>

			<router-link to="/choisir-son-personnage" class="validate-action-back btn" @click="resetCookies"><span></span> Recommencer l'aventure</router-link>
  	</template>
  </div>
</template>

<script>
	import Transition from '~mixins/Transition';
	import Cookie from 'js-cookie';
	import Socials from '../ui/socials/Socials';

  export default {
		name: 'end-page',
		components: {
			Socials,
		},
		mixins: [Transition],
		data() {
			return {
				end: null,
			};
		},
		created() {
			this.initData();
		},
		methods: {
			initData() {
				if (this.getWin) {
					if (this.getMoney <= 10) {
						this.end = this.getEndData.win_1;
					} else if (this.getMoney > 10 && this.getMoney <= 20) {
						this.end = this.getEndData.win_2;
					} else {
						this.end = this.getEndData.win_3;
					}
				} else {
					this.end = this.getEndData.loose;
				}
			},
			resetCookies() {
				Cookie.remove('player');
				Cookie.remove('question');
				Cookie.remove('money');
			},
		},
		watch: {
			getEndData() {
				this.initData();
			},
		},
		computed: {
			getWin() {
				return this.$store.getters.getWin;
			},
			getMoney() {
				return this.$store.getters.getMoney;
			},
			getEndData() {
				return this.$store.getters.getEndData;
			},
			getPlayer() {
				return this.$store.getters.getPlayer;
			},
		},
  };
</script>


<style lang="scss">
	.end-page {
		width: 100%;
		padding-top: 100px;

		@include tablet {
			padding-top: 200px;
		}

		@include mobile {
			padding-top: 0;
		}

		h2 {
			color: $white;
			text-align: center;
			margin-top: 0;
		}

		.end-page__score {
			text-align: center;
			color: $white;
			margin-bottom: 30px;
			@include fontSize(60);
		}

		.end-page__characters {
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			animation: appearBottom .4s .1s ease-in-out forwards;

			img {
				width: 150px;
				max-width: 45%;

				&:first-child {
					margin-right: 50px;

					@include mobile {
						margin-right: 5%;
					}
				}
			}
		}

		.end-page__text {
			width: 800px;
			max-width: 90%;
			margin: 50px auto;
			color: $white;
			text-align: center;
			line-height: 1.6;
			opacity: 0;
			animation: appearBottom .4s .2s ease-in-out forwards;
			@include fontSize(18);
		}

		.end-page__share {
			width: 350px;
			margin: auto;
			opacity: 0;
			animation: appearBottom .4s .3s ease-in-out forwards;

			@include mobile {
				width: 90%;
			}

			> div {			
				position: relative;
				display: flex;
				align-items: center;
				background: $white;
				padding: 13px 30px;
				justify-content: center;
				flex-wrap: wrap;

				@include mobile {
					flex-wrap: wrap;
					text-align: center;
					justify-content: center;
				}

				> * {
					position: relative;
					z-index: 10;
				}

				&::before {
					position: absolute;
					z-index: 5;
					top: -5px;
					right: -3px;
					left: -4px;
					bottom: -5px;
					background: url('../../assets/img/border_btn.png') no-repeat;
					content: '';
					background-size: 100% 100%;
				}
			}

			p {
				color: $orange;
				@include fontSize(18);

				@include mobile {
					margin-bottom: 15px;
				}
			}

			.socials {
				margin-top: 5px;
				padding-right: 0;

				a {
					position: relative;
					top: 2px;
					color: $blue;

					&:hover {
						color: $orange;
					}
				}
			}
		}

		.validate-action-back {
			display: block;
			text-align: center;
			text-decoration: none;
			width: 305px;
			margin: 30px auto;
			opacity: 0;
			animation: appearBottom .4s .5s ease-in-out forwards;

			@include mobile {
				width: 90%;

				span {
					display: none;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// End.vue?7c5d9e11